var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellSimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_1479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24.5H17.5",
    stroke: "#232323",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12364 11.375C6.12364 9.28642 6.95333 7.28338 8.43018 5.80653C9.90703 4.32969 11.9101 3.5 13.9986 3.5C16.0872 3.5 18.0903 4.32969 19.5671 5.80653C21.044 7.28338 21.8736 9.28642 21.8736 11.375C21.8736 15.2928 22.7815 18.4406 23.5033 19.6875C23.58 19.8203 23.6204 19.9709 23.6206 20.1242C23.6207 20.2776 23.5805 20.4282 23.5041 20.5612C23.4277 20.6941 23.3177 20.8046 23.1851 20.8816C23.0525 20.9586 22.902 20.9995 22.7486 21H5.24864C5.0955 20.9991 4.94527 20.958 4.81299 20.8808C4.6807 20.8036 4.57099 20.6931 4.49482 20.5602C4.41864 20.4274 4.37867 20.2768 4.37891 20.1237C4.37914 19.9705 4.41957 19.8201 4.49614 19.6875C5.21692 18.4406 6.12364 15.2917 6.12364 11.375Z",
    stroke: "#232323",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_1479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellSimple);
export default __webpack_public_path__ + "static/media/BellSimple.87c5db3954d6f7c29bb536ac62ee410f.svg";
export { ForwardRef as ReactComponent };